import { LazoLogo } from "@/components/drawer-components/LazoLogo";
import { Colors } from "@/enums/Colors";
import { ConversationType } from "@/types/ConversationType";
import { useConversationTypeIdentifier } from "@/utils/LocationUtils";
import { Box, Stack, SxProps, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import CrunchbaseLogo from "../../../assets/images/crunchbase-logo.svg";

const LazoLogoContainerProps: SxProps = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  marginTop: "5rem",
  gap: "0.5rem",
};

const CrunchbaseLogoContainerProps: SxProps = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  paddingTop: "0.5rem",
};

function LazoAiChatWelcomeMessage() {
  const theme = useTheme();
  const convType = useConversationTypeIdentifier();
  const { t } = useTranslation("chat");

  const welcomeAugmentedOpsButton = () => {
    return (
      <Box
        sx={{
          marginTop: "1rem !important",
          width: "17.5rem",
          height: "2.75rem",
          border: "1px solid",
          borderRadius: "6.25rem",
          borderColor: Colors.BUTTON_PURPLE,
          backgroundColor: Colors.BUTTON_SECONDARY_PURPLE,
        }}
        justifyContent={"center"}
        alignContent={"center"}
        textAlign={"center"}
      >
        <Typography fontSize={"1rem"} fontWeight={"600"} lineHeight={"1.25rem"} color={Colors.BLACK_2}>
          {t("aiDrawer.welcomeMessage.welcomeTo")}{" "}
          <span style={{ color: Colors.BUTTON_HOVER_PURPLE }}>{t("aiDrawer.welcomeMessage.augmentedOps")}</span>
        </Typography>
      </Box>
    );
  };

  return (
    <>
      <Stack
        spacing={1}
        alignItems={"center"}
        justifyContent={"center"}
        sx={{
          [theme.breakpoints.up("md")]: {
            height: "78%",
          },
          [theme.breakpoints.down("md")]: {
            height: "67%",
          },
        }}
      >
        {/* Welcome Message */}
        <LazoLogo
          containerSxProps={LazoLogoContainerProps}
          imageWidth={useMediaQuery(theme.breakpoints.down("md")) ? "40%" : "22%"}
          includeStar={true}
        />
        <Box style={{ maxWidth: "380px", textAlign: "center" }} sx={{ whiteSpace: "normal" }}>
          <Typography
            display={useMediaQuery(theme.breakpoints.down("sm")) ? "none" : "block"}
            fontSize={"0.875rem"}
            fontWeight={"600"}
            lineHeight={"1.25rem"}
          >
            {t("aiDrawer.welcomeMessage.assistQuestion")}
          </Typography>
        </Box>

        {convType === ConversationType.FUNDRAISING ? (
          <Box sx={{ marginTop: "1rem !important" }}>
            <Typography
              sx={{
                fontSize: "10px",
                color: Colors.STONE_GRAY,
                textAlign: "center",
              }}
            >
              {t("aiDrawer.welcomeMessage.poweredBy")}
            </Typography>
            <Box sx={CrunchbaseLogoContainerProps}>
              <img src={CrunchbaseLogo.src} alt={t("aiDrawer.welcomeMessage.alt.crunchbaseLogo")} style={{ maxWidth: "150px" }} />
            </Box>
          </Box>
        ) : (
          welcomeAugmentedOpsButton()
        )}
      </Stack>
    </>
  );
}

export default LazoAiChatWelcomeMessage;
